namespace $.$$ {
	export class $shm_hitalama_audio_player extends $.$shm_hitalama_audio_player {

		duration_probe_active = false

		audio_node() {
			return this.Audio().dom_node() as HTMLAudioElement
		}

		@ $mol_mem
		duration_value( next?: number ) {
			return next ?? 0
		}

		@ $mol_mem
		audio_sink() {
			const audio = this.audio_node() as HTMLAudioElement & {
				sinkId?: string
				setSinkId?: ( sinkId: string )=> Promise< void >
			}
			const sink = $shm_hitalama_settings.speaker()
			const set_sink_id = Reflect.get( audio, 'setSinkId' )

			if( typeof set_sink_id === 'function' && audio.sinkId !== sink ) {
				$mol_wire_sync( audio ).setSinkId!( sink )
			}

			return sink
		}

		@ $mol_mem
		uri_loaded() {
			this.audio_sink()

			const uri = this.uri()
			const audio = this.audio_node()

			if( uri && audio.src !== uri ) {
				this.duration_value( 0 )
				this.duration_probe_active = false
				audio.src = uri
				audio.load()
			}

			return uri
		}

		@ $mol_mem
		override playing( next?: boolean ) {
			this.uri_loaded()

			const audio = this.audio_node()
			this.sync_playing()

			if( next !== undefined ) {
				if( next && audio.paused ) {
					const started = audio.play()
					started.catch( ()=> this.playing( false ) )
				} else if( !next && !audio.paused ) {
					audio.pause()
				}
			}

			return !audio.paused
		}

		@ $mol_mem
		override time( next?: number ) {
			this.uri_loaded()
			this.sync_time()

			if( next !== undefined ) {
				const audio = this.audio_node()
				return audio.currentTime = Math.max( 0, Math.min( next, this.duration() || next ) )
			}

			const audio = this.audio_node()
			return audio.ended ? this.duration() : audio.currentTime || 0
		}

		@ $mol_mem
		override duration() {
			this.uri_loaded()
			this.sync_duration()

			const duration = this.audio_node().duration
			return Number.isFinite( duration ) ? duration : this.duration_value()
		}

		@ $mol_action
		override sync_duration( next?: Event ) {
			if( next === undefined ) return null

			const audio = this.audio_node()
			const duration = audio.duration

			if( Number.isFinite( duration ) ) {
				this.duration_value( duration )

				if( this.duration_probe_active && next.type === 'seeked' && audio.currentTime ) {
					audio.currentTime = 0
					this.sync_time( next )
					this.duration_probe_active = false
				}

				return next
			}

			if( audio.paused && !this.duration_probe_active && audio.readyState >= HTMLMediaElement.HAVE_METADATA ) {
				this.duration_probe_active = true
				audio.currentTime = Number.MAX_SAFE_INTEGER
			}

			return next
		}

		@ $mol_mem
		override slider_time( next?: number ) {
			if( next !== undefined ) return this.time( next )

			const time = this.time()
			const duration = this.duration()
			if( duration && duration - time <= .5 ) return duration

			return time
		}

		@ $mol_action
		sync_end( next?: Event ) {
			const audio = this.audio_node()
			const duration = this.duration()
			if( duration ) audio.currentTime = duration

			this.sync_time( next )
			this.sync_playing( next )
			return null
		}

	}
}
